import { SellerAnalyticsModal } from '../../../../components/PageWrappers/SharedComponents/SellerAnalyticsModal/SellerAnalyticsModal';
import type { ISellerAnalyticsModal } from '../../../../components/PageWrappers/SharedComponents/SellerAnalyticsModal/SellerAnalyticsModal';
import type { ReactNode } from 'react';

import { accountsApi } from '../../../../api/accountsApi';

import { fireToast } from '../../../../helpers/Toasts';

import { combinePlotValues } from '../../../../components/PageWrappers/SharedComponents/SellerAnalyticsModal/helpers';

import type { PlotValue } from '../../../../types';
import {
  SELLER_ANALYTICS_CATEGORIES,
  SELLER_ANALYTICS_TIME_RANGES,
} from '../../../../types';
import { formatAuthorizationHeader } from '../../../../helpers/auth';
import { useAuthOptions } from '../../../../hooks/useAuthOptions';

interface IRevealSellerAnalyticsModal
  extends Omit<ISellerAnalyticsModal, 'fetchSellerAnalyticsData'> {
  setSellerAnalyticsData: (v: {
    title?: string | ReactNode;
    selectedTab: SELLER_ANALYTICS_CATEGORIES;
    data: PlotValue[];
  }) => void;
  adId: number;
  userId: number;
}

function RevealSellerAnalyticsModal({
  title,
  adId,
  userId,
  setSellerAnalyticsData,
  ...rest
}: IRevealSellerAnalyticsModal) {
  const { accessToken } = useAuthOptions();

  async function fetchSellerAnalyticsData(
    category: SELLER_ANALYTICS_CATEGORIES,
    range: SELLER_ANALYTICS_TIME_RANGES,
  ) {
    try {
      const { data } = await accountsApi.getSellerAnalyticsData(
        userId,
        adId,
        category,
        range,
        formatAuthorizationHeader(accessToken),
      );

      // if range is '90' flatten data into weekly segments
      if (range === '90') {
        const updatedPlotValues = combinePlotValues(data.plotValues, 7);
        setSellerAnalyticsData({
          title,
          selectedTab: category,
          data: updatedPlotValues,
        });
      } else {
        setSellerAnalyticsData({
          title,
          selectedTab: category,
          data: data.plotValues,
        });
      }
    } catch (_error) {
      fireToast({
        type: 'ERROR',
        text: 'Oops! Something went wrong, please try again later',
      });
    }
  }

  return (
    <SellerAnalyticsModal
      showCloseIcon
      title={title}
      fetchSellerAnalyticsData={fetchSellerAnalyticsData}
      {...rest}
    />
  );
}

export { RevealSellerAnalyticsModal };
